module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Page', {
    staticClass: "ProjectConfirmation"
  }, [_c('img', {
    staticClass: "Logo",
    class: {
      'Logo--right': _vm.logoPosition === 'right'
    },
    attrs: {
      "src": _vm.logoSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ProposalInfo"
  }, [_c('span', {
    staticClass: "Proposal-Info-Number"
  }, [_vm._v(_vm._s(_vm.projectType) + " Nr. " + _vm._s(_vm.projectNumber))]), _vm._v(" "), _c('span', {
    staticClass: "Proposal-Info-Date"
  }, [_vm._v("vom " + _vm._s(_vm.projectDate))])]), _vm._v(" "), _c('h2', {
    staticClass: "ProjectConfirmation-Title"
  }, [_vm._v("Rechnungslegung")]), _vm._v(" "), _c('article', {
    ref: "projectConfirmation"
  }), _vm._v(" "), _c('div', {
    staticClass: "Signature"
  }, [_vm._v("Datum, Unterschrift, Stempel")]), _vm._v(" "), _c('CompanyAddress', {
    attrs: {
      "company": _vm.company
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb3f2c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/ConfirmationPage.vue
// module id = 167
// module chunks = 4